module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_header-b25d93dfa278d0ba0c0625e0c73e0e2b.webp";